import type { AgendaColumnType } from "../columns/agenda-column-type";
import { agendaColumnZodEnum } from "../columns/agenda-column-type";

const agendaListZodEnum = agendaColumnZodEnum;
type AgendaListType = AgendaColumnType;

export { agendaListZodEnum };
export type { AgendaListType };
